const d = (i) => {
  const { width: e, height: t, aspectRatio: n } = i;
  return typeof n < "u" ? 100 / n : typeof t < "u" && typeof e < "u" ? 100 * (t / e) : 100;
};
export {
  d as calculatePlaceholderHeight
};
